<template>
    <div>
        <a-modal :closable="false" :maskClosable="false" v-model="visible" title="修改发票信息">
            <a-form :form="form" v-bind="formItemLayout">
                <a-form-item v-bind="formItemLayout" label="发票号码">
                    <a-input placeholder="请输入发票号码" :disabled="true" v-decorator="[
            'invoiceNumber',
            {
                rules: [
                    {
                        required: true,
                        message: '请输入发票号码',
                    },
                ],
            },
        ]" />
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="发票代码">
                    <a-input placeholder="请输入发票代码" :disabled="true" v-decorator="[
            'invoiceCode',
            {
                rules: [
                    {
                        required: true,
                        message: '请输入发票代码',
                    },
                ],
            },
        ]" />
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="发票状态">
                    <a-select v-decorator="[
            'status',
            { rules: [{ required: true, message: '请选择发票状态' }] },
        ]" placeholder="请选择发票状态">
                        <a-select-option v-for="(item, index) in statusEnum" :key="index" :value="index">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="编码">
                    <a-select v-decorator="[
            'errCode',
            { rules: [{ required: true, message: '请选择编码' }] },
        ]" placeholder="请选择编码" @change="codeOnChange">
                        <a-select-option value="22017">
                            22017
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="文字">
                    <a-select :disabled='true' v-decorator="[
            'reason',
            { rules: [{ required: true, message: '请选择文字' }] },
        ]" placeholder="请选择文字">
                        <a-select-option value="22017">
                            查验异常
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
                    提交
                </a-button>
            </template>

        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['visible', 'formData', 'batchNo'],
    data() {
        return {
            form: this.$form.createForm(this, { name: 'batch' }),
            loading: false,
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 18 },
                },
            },
            statusEnum: {
                0: '正常',
                1: '失控',
                2: '作废',
                3: '红冲',
                4: '异常',
                7: '部分红冲',
                8: '全额红冲'
            }
        };
    },
    methods: {
        async handleOk(e) {
            let formValue = await this.form.validateFields()
            let msgEnum = {
                '22017': '查验异常'
            }
            let params = {
                batchNo: this.batchNo,
                list: [{
                    ...formValue,
                    reason: msgEnum[formValue.reason]
                }]
            }
            this.loading = true;
            // 如果成功了，提示成功，返回列表页
            // 如果失败了，提示失败
            await this.http.post('/ystOpenPlatformBff/tool/updateBatchCheckDetail', params, res => {
                if (res.success) {
                    this.$message.success('操作成功！')
                    this.$emit('setModalIsShow', false)
                    this.form.resetFields()
                    this.$emit('getTableList')
                } else {
                    this.$message.warning('操作失败，请检查发票信息后重试！')
                }
            })
            this.loading = false;
        },
        handleCancel() {
            this.$emit('setModalIsShow', false)
        },
        codeOnChange(value) {
            this.form.setFieldsValue({
                reason: value
            })
        },
    },
    mounted() {
        let { invoiceNumber,
            invoiceCode,
            status,
            errCode,
        } = this.formData
        this.form.setFieldsValue({
            invoiceNumber,
            invoiceCode,
            status,
            errCode,
            reason: errCode
        })
    },
};
</script>


// WEBPACK FOOTER //
// src/page/BatchModal.vue